module.exports = __webpack_public_path__ + "img/symbol_11.aa916506.png";